import React, { useEffect, useState  } from 'react';
import ContactModal from "../components/ContactModal";
import CustomerSay from "../components/CustomerSay";
import SeoHelmet from "../components/SeoHelmet";

import icon1 from "../assets/img/privacy_banner_icon.png";
import icon2 from "../assets/img/info_icon1.png";
import icon3 from "../assets/img/dot.svg";
import icon4 from "../assets/img/info_icon2.png";
import icon5 from "../assets/img/info_icon3.png";
import icon6 from "../assets/img/info_icon4.png";
import icon7 from "../assets/img/info_icon5.png";
import icon8 from "../assets/img/info_icon6.png";
import icon9 from "../assets/img/info_icon7.png";
import icon10 from "../assets/img/info_icon8.png";



import Map from "../assets/img/map_img.jpg";

const PrivacyPolicy = () => {

  const [activeVideo, setActiveVideo] = useState(null);

  const handleOpenModal = (videoSrc) => {
    setActiveVideo(videoSrc); // Set the active video source
  };

  const handleCloseModal = () => {
    setActiveVideo(null); // Clear the active video source
  };

  useEffect(() => {

    if (window.Swiper) {

 
      const custswiper = new window.Swiper(".customerslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        pagination: {
          el: ".swiper-paginationnn",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
            slidesPerGroup: 3,

          },
          // You can add more breakpoints if needed
        },

      });

    }




  }, []);

  return (
    <>
      <SeoHelmet />
      
      <section>
        <div className="swiper animeslide">
          <div className="swiper-wrapper">
            <div
              className="swiper-slide  slide1 about_us_slide privacy_policy"
            >
              <div className="container">
                <div className="row">
                  <div className="col-sm-12 banner_content">
                    <img src={icon1} alt=""/>
                        <h2>Privacy Policy</h2>
                        <h4>Workdayz.in</h4>
                        <p>Last updated: 28 January 2026</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='privacy_content'>
         <div className="container"> 
               <div className="row">
                 <div className="col-sm-12">
                  <p className='update'>Last updated: 28 January 2026</p>
                  <p>Workdayz ("Workdayz") is a sub-brand of The Saraogi Clothing Company ("Saraogi"). This Privacy Policy explains how we collect, use, share, and protect personal information when you visit workdayz.in ("Website"), interact with our ads, or contact us.</p>
                  <p>By using this Website, you agree to this Privacy Policy.</p>
                 </div>
               </div>
          </div>
      </section>

      <section className='privacy_info'>
         <div className="container"> 
           <div className="row">
              <div className="col-sm-6">
                <div className='info_left'>
                    <div className='info_detail'>
                          <div className='info_detail_img'>
                             <img src={icon2} alt=""/>
                             <h2> Information We Collect</h2>
                          </div>
                          <h3>A. Information you provide</h3>
                          <ul>
                            <li><img src={icon3} alt=""/>Name, email address, phone number</li>
                            <li><img src={icon3} alt=""/>Company name, designation, business details</li>
                            <li><img src={icon3} alt=""/>Enquiry details, measurements/specifications you share for uniforms (if provided)</li>
                            <li><img src={icon3} alt=""/>Messages shared via forms, email, or WhatsApp links</li>
                          </ul>

                          <h3>B. Information collected automatically</h3>
                          <ul>
                            <li><img src={icon3} alt=""/>IP address, browser type, device identifiers</li>
                            <li><img src={icon3} alt=""/>Pages viewed, clicks, time spent, referring/exit pages</li>
                            <li><img src={icon3} alt=""/>Approximate location (city/region) inferred from IP</li>
                            <li><img src={icon3} alt=""/>Cookies and similar tracking technologies</li>
                          </ul>

                          <h3>C. Information from third parties</h3>
                          <ul>
                            <li><img src={icon3} alt=""/>Lead data from Meta/Instagram forms or other ad platforms if you submit an enquiry through ads</li>
                            <li><img src={icon3} alt=""/>Analytics and measurement data from partners (e.g., Meta Pixel, Google </li>
                            <li><img src={icon3} alt=""/>Analytics or similar tools if used)</li>
                          </ul>
                    </div>

                     <div className='info_detail'>
                          <div className='info_detail_img'>
                             <img src={icon4} alt=""/>
                             <h2>  How We Use Your Information</h2>
                          </div>
                          <p>We use personal information to:</p>
                          <ul>
                            <li><img src={icon3} alt=""/>Respond to enquiries, share quotations, and provide customer support</li>
                            <li><img src={icon3} alt=""/>Provide and improve our products/services (uniforms, business solutions, communication)</li>
                            <li><img src={icon3} alt=""/>Personalize Website experience and understand usage trends</li>
                            <li><img src={icon3} alt=""/>Run marketing campaigns, including remarketing/retargeting</li>
                             <li><img src={icon3} alt=""/>Measure ad performance and conversions</li>
                              <li><img src={icon3} alt=""/>Detect, prevent, and address fraud, abuse, or security issues</li>
                               <li><img src={icon3} alt=""/>Comply with legal obligations and enforce our rights</li>
                          </ul>
                         
                    </div>

                     <div className='info_detail'>
                          <div className='info_detail_img'>
                             <img src={icon5} alt=""/>
                             <h2>  Cookies, Pixels & Remarketing</h2>
                          </div>
                          <p>We use cookies and similar technologies (including pixels) to:</p>
                          <ul>
                            <li><img src={icon3} alt=""/>Operate and improve the Website</li>
                            <li><img src={icon3} alt=""/>Remember preferences</li>
                            <li><img src={icon3} alt=""/>Analyze traffic and user behavior</li>
                            <li><img src={icon3} alt=""/>Deliver and measure ads, including remarketing (showing ads to people who have visited our Website or interacted with our content)</li>
                          </ul>
                          <h4>Meta remarketing:</h4>
                          <p>We may use Meta tools (e.g., Meta Pixel / Conversions API where enabled) to measure campaigns and build audiences for retargeting. Meta may process data according to its own policies.</p>
                          <p>You can manage cookies through your browser settings. You can also control ad preferences through the relevant platform settings (e.g., Facebook/Instagram ad preferences). Disabling cookies may affect Website functionality.</p>
                         
                    </div>

                      <div className='info_detail'>
                          <div className='info_detail_img'>
                             <img src={icon6} alt=""/>
                             <h2>   Sharing of Information</h2>
                          </div>
                          <p>We do not sell personal information.</p>
                           <p>We may share information with:</p>
                          <ul>
                            <li><img src={icon3} alt=""/>Service providers who help us run our business (hosting, analytics, CRM/email tools, advertising partners)</li>
                            <li><img src={icon3} alt=""/>Advertising/measurement partners for campaign delivery and reporting (including remarketing)</li>
                            <li><img src={icon3} alt=""/>Legal/regulatory authorities if required by law, or to protect rights, safety, and security</li>
                            <li><img src={icon3} alt=""/>Business transfers (merger, acquisition, restructuring) where data may be transferred as part of business assets</li>
                          </ul>
                          <p>Where we use vendors, we share only what is necessary and expect reasonable safeguards.</p>
                    </div>
                </div>
              </div>
               <div className="col-sm-5">
                    <div className='info_left'>
                     <div className='info_detail '>
                          <div className='info_detail_img info_img'>
                             <img src={icon7} alt=""/>
                             <h2>   Data Security</h2>
                          </div>
                          <p>We use reasonable administrative, technical, and physical safeguards to protect personal information. However, no internet transmission or storage system is completely secure, so we cannot guarantee absolute security.</p>     
                    </div>

                    
                      <div className='info_detail'>
                          <div className='info_detail_img info_img'>
                             <img src={icon2} alt=""/>
                             <h2> Data Retention</h2>
                          </div>
                          <p>We retain personal information only for as long as necessary to:</p>
                          <ul>
                            <li><img src={icon3} alt=""/>Respond to enquiries and provide services</li>
                            <li><img src={icon3} alt=""/>Maintain business records and meet legal/accounting requirements</li>
                            <li><img src={icon3} alt=""/>Resolve disputes and enforce agreements</li>
                        
                          </ul>
                          <p>We then delete, anonymize, or securely store it as required.</p>
                    </div>

                     <div className='info_detail'>
                          <div className='info_detail_img info_img'>
                             <img src={icon8} alt=""/>
                             <h2>  Your Rights & Choices</h2>
                          </div>
                          <p>Subject to applicable law, you may request to:</p>
                          <ul>
                            <li><img src={icon3} alt=""/>Access, correct, or update your personal information</li>
                            <li><img src={icon3} alt=""/>Delete your information (where legally permissible)</li>
                            <li><img src={icon3} alt=""/>Opt out of marketing communication</li>
                        
                          </ul>
                          <p>To make a request, email us at <a href='#'>info@workdayz.in.</a> </p>
                    </div>

                     <div className='info_detail'>
                          <div className='info_detail_img info_img'>
                             <img src={icon9} alt=""/>
                             <h2> Third-Party Links</h2>
                          </div>
                          <p>The Website may include links to third-party platforms (e.g., WhatsApp, social media). We are not responsible for their privacy practices. Please review their policies separately.</p>     
                    </div>

                     <div className='info_detail'>
                          <div className='info_detail_img info_img'>
                             <img src={icon6} alt=""/>
                             <h2> Children's Privacy</h2>
                          </div>
                          <p>This Website is intended for business users and general audiences. We do not knowingly collect personal information from children. If you believe a child has provided data, contact us and we will take appropriate steps.</p>     
                    </div>

                     <div className='info_detail'>
                          <div className='info_detail_img info_img'>
                             <img src={icon10} alt=""/>
                             <h2>  Contact Details</h2>
                          </div>
                          <p>For questions or privacy requests, contact:</p>   
                          <p>Workdayz (sub-brand of The Saraogi Clothing Company)</p> 
                          <p>Email: info@workdayz.in</p> 
                          <p className='update' >(If you want, add your office address + phone here for completeness.)</p>   
                    </div>

                    <div className='info_detail'>
                          <div className='info_detail_img info_img'>
                             <img src={icon5} alt=""/>
                             <h2>  Updates to This Policy</h2>
                          </div>
                          <p>We may update this Privacy Policy from time to time. The updated version will be posted on this page with a revised "Last updated" date. Continued use of the Website after changes means you accept the updated policy.</p>     
                    </div>

                    </div>
               </div>
            </div> 
         </div>
      </section>

      <section className='privacy_ques'>
          <div className="container">
              <div className="privacy_about">
              
                <h2>Questions About Our Privacy Policy?</h2>
                 <p>If you have any questions or concerns, please don't hesitate to reach out to us.</p>   
                   <div data-animate="bottom" className="animeslide-desc">
                        <a href="/contact" >Contact Us</a>
                      </div>
              </div>
          </div> 
      </section>
      
      
    </>
  );
};

export default PrivacyPolicy;
